var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundGraphic = function SvgBackgroundGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1948,
    height: 2308,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    clipPath: "url(#background-graphic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.28,
    d: "M14.89 2303.79c205.38-270.27 187.41-319.04 340.99-479.08S688.66 1549 800.19 1325.83s73.69-432.76 225.97-517.4c152.28-84.65 224.74-20.89 302.05-137.2s88.85-304.72 156.83-391.23c58.52-74.48 79.93 52.36 235.81-156.15",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.31,
    d: "M29.69 2299.79c205.38-270.27 146.56-339.41 300.14-499.45s381.77-241.04 493.29-464.21c111.53-223.17 34.74-453.03 187.02-537.68s220.45 38.33 297.76-77.97c77.31-116.31 77.28-322.35 156.05-419.85 59.51-73.66 148.23 25.61 289.26-194.48",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.34,
    d: "M44.48 2295.78c205.38-270.27 105.7-359.78 259.28-519.82s430.75-206.36 542.28-429.53-4.21-473.31 148.07-557.96 216.16 97.56 293.46-18.75c77.31-116.31 65.58-340.08 155.27-448.46 60.37-72.95 216.53-1.15 342.71-232.8",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.38,
    d: "M59.28 2291.78c205.38-270.27 64.85-380.15 218.43-540.19s479.73-171.69 591.26-394.86-43.16-493.59 109.12-578.24 211.86 156.79 289.17 40.48 53.75-357.92 154.5-477.07c61.14-72.31 284.83-27.91 396.16-271.12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.41,
    d: "M74.07 2287.78c205.38-270.27 23.99-400.52 177.57-560.56s528.72-137.01 640.24-360.18c111.53-223.17-82.11-513.87 70.17-598.52s207.57 216.01 284.88 99.71c77.31-116.31 41.8-375.86 153.72-505.68 61.84-71.73 353.13-54.67 449.61-309.44",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.44,
    d: "M88.87 2283.78c205.38-270.27-16.86-420.89 136.72-580.93s577.7-102.33 689.23-325.5-121.06-534.14 31.22-618.79 203.28 275.24 280.58 158.93c77.31-116.31 29.72-393.92 152.94-534.3 62.5-71.2 421.43-81.43 503.06-347.77",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.47,
    d: "M103.66 2279.77c205.38-270.27-57.72-441.26 95.86-601.3s626.68-67.66 738.21-290.83S777.72 833.22 930 748.57s198.98 334.47 276.29 218.16 17.52-412.09 152.17-562.91c63.12-70.7 489.73-108.18 556.51-386.09",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M118.45 2275.77c205.38-270.27-98.57-461.64 55.01-621.68s675.67-32.98 787.19-256.15c111.53-223.17-198.96-574.7-46.68-659.35s194.69 393.69 272 277.39c77.31-116.31 5.2-430.38 151.39-591.52 63.71-70.23 558.04-134.94 609.96-424.42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "background-graphic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1947.57v2307.87H0z"
  })))));
};
export default SvgBackgroundGraphic;